import { z } from 'zod'

/** What an agent API key may do in the catalog. Agents can never edit, archive, or delete. */
export const CATALOG_AGENT_ACTIONS = ['read', 'create'] as const
export const AGENT_KEY_EXPIRATION_DAYS = [30, 90, 365] as const

export const createAgentKeySchema = z.object({
  name: z.string().trim().min(1).max(60),
  catalog: z
    .array(z.enum(CATALOG_AGENT_ACTIONS))
    .min(1)
    .refine((actions) => new Set(actions).size === actions.length),
  expiresInDays: z.union(AGENT_KEY_EXPIRATION_DAYS.map((days) => z.literal(days))).nullable(),
})

export type CatalogAgentAction = (typeof CATALOG_AGENT_ACTIONS)[number]
export type CreateAgentKeyInput = z.infer<typeof createAgentKeySchema>
